import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { transformDateFormat } from 'utils/StringUtils';
import { Link } from 'react-router-dom';
import { TagList } from 'components/commons';
import moment from 'moment';
import EmptyData from 'components/commons/EmptyData';
import {
  formatNum,
  getIssueDetailUrlPrefix,
  convertIssueAssigneeListToDisplayText
} from 'utils/helper';
import { Translation, useTranslation } from 'react-i18next';
import { Button, Col, DatePicker, Select, Space, Spin, Tooltip, Table, Row, Radio } from 'antd';
import {
  TopIssueCompareType,
  TopIssueSortField,
  TopIssueUtils
} from 'components/exception/ProductSummaryPage/TopIssueList/TopIssueList';
import CardHead from 'components/commons/CardHead';
import { connect, useSelector } from 'react-redux';
import XLSX from 'xlsx';
import { CountryUtil } from 'utils/country';
import CountrySelect from 'components/exception/ProductSummaryPage/CountrySelect';
import SortButton from 'components/exception/ProductSummaryPage/SortButton';
import CsClampDiv from 'components/commons/CsClampDiv/CsClampDiv';
import { useImmer } from 'use-immer';
import VersionHybridSelect from 'components/commons/VersionHybridSelect';
import { CsvUtil } from 'utils/csv-util';
import { VersionUtil } from 'utils/version-util';
import { orange } from '@ant-design/colors';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { DemoUtil } from 'utils/demo-util';
import { TimeUtil } from 'utils/time-util';
import { ze, isZh } from 'utils/zhEn';
import { formatEnNumber } from 'utils/format/format-number';
import { selectCurrentAppDatePickerAvailableMomentRange } from 'utils/selectors/selectors';
import { DividerWithTime } from './DividerWithTime';
import topIssueListScss from './TopIssueList/style.scss';
import IssueTapdBugStatusEx from 'components/exception/BaseProblemPage/IssueItem/IssueTapdBugStatusEx';
import reportEvent, { EVENT_ACTIONS, ReportEventUtil } from 'utils/reportEvent';
import HourlyTopIssiueIcon from 'svg/v2/newcs_dashboard_overview_hourlytopissues_icon.svg';
import { UpdateTimeTag } from './UpdateTimeTag';
import CsDownloadButton from 'components/commons/CsDownloadButton/CsDownloadButton';
import IssueIdIcon from 'svg/v2/newcs_dashboard_overview_dailytopissue_list_issueid_icon.svg';
import IssueNameIcon from 'svg/v2/newcs_dashboard_overview_dailytopissue_list_yichangname_icon.svg';
import StatusItem from 'components/commons/StatusItem/StatusItem';
import CsCollapseButton from 'components/commons/CsCollapseButton/CsCollapseButton';
import DateSelectIcon from 'svg/v2/newcs_dashboard_dateselect_icon.svg';
import WrappedTipsIcon from 'components/antd-extension/WrappedTipsIcon.jsx';
import { CS_STYLES } from 'utils/constants/style-constants';
import { PlatformUtil } from 'utils/platform';
import VmTypeSelect from 'components/exception/ProductSummaryPage/VmTypeSelect';
import UserSceneTagSelect from 'components/exception/ProductSummaryPage/UserSceneTagSelect';
import { VmTypeUtil } from 'utils/constants/vm-type';
import { ix } from 'utils/i18n-with-context';
import VitalOrCrashSelect from 'components/exception/ProductSummaryPage/VitalOrCrashSelect';
import { ExceptionCategoryUtil } from 'utils/exception-category';
import SearchItemScss from 'components/exception/SeniorSearchPage/SearchItem/style.scss';
import IssueCrashFilterEx from 'components/commons/IssueCrashFilter/IssueCrashFilterEx';
import { FieldName, QueryType } from 'components/commons/IssueCrashFilter/IssueCrashFilterExUtil';
import { ServerAppSettings } from 'utils/server-app-settings';


const ALL_VERSION = '-1';

const FIELDS = Object.freeze({
  DEVICES: 'DEVICES',
  NUM: 'NUM',
  FLUCTUATE_PREV_DAY: 'FLUCTUATE_PREV_DAY',
  FLUCTUATE_PREV_HOUR: 'FLUCTUATE_PREV_HOUR',
  FIRST_TIME: 'FIRST_TIME',
});

function getExceptionCategory(issueExceptionType) {
  return ExceptionCategoryUtil.fromExceptionTypeInt(issueExceptionType);
}

function formatRate(numerator, denominator) {
  if (parseInt(denominator) === 0) {
    return '0 %';
  }
  return TopIssueUtils.formatPercentage(100 * numerator / denominator);
}

/**
 * collapseIssues,onToggleCollapseIssues 暂时用不到了，使用 isExpanded
 */
const RealTimeTopIssue = ({
  demoApp,
  collapseIssues,
  realTimeTopIssueData,
  handleChangeStatus,
  onToggleCollapseIssues,
  onClickUpsertTapdBugByIssueIdList,
  onBugUnbind,
  style,
  pageType,
  patchQueryParams,
  onRealTimeTopIssueParamsChange,
  members,
  actions,
  reduxState,
  isRegionalDashboard,
  enableUserSceneTag,
}) => {
  const { t, i18n } = useTranslation();

  const currentApp = useMemo(() => reduxState.app.get('current').toJS(), [reduxState.app.get('current')]);
  const { appId, pid } = currentApp;
  const bugTrackingSimplifiedInfo = useMemo(() => reduxState.app.get('appIdToBugTrackingSimplifiedInfo')?.[appId],
    [reduxState.app, appId]);
  const { tapdWorkspaceId, jiraProjectId } = bugTrackingSimplifiedInfo || {};
  const showBugStatusField = !!tapdWorkspaceId || !!jiraProjectId;

  const serverAppSettings = useMemo(() => reduxState.app.get('appIdToServerAppSettings')?.[appId] || {},
    [reduxState.app, appId]);
  // 是否是先锋云游戏项目
  const isAppGameMatrix = !!serverAppSettings[ServerAppSettings.keys.isAppGameMatrix];

  const [
    datePickerMinAvailableMoment,
    datePickerMaxAvailableMoment
  ] = useSelector(selectCurrentAppDatePickerAvailableMomentRange);

  const [isExpanded, setIsExpanded] = useState(false);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [itemIndexToIsHovering, updateItemIndexToIsHovering] = useImmer({});

  function renderIssue(actions, demoApp, curIssueData, handleChangeStatus, style, pageType, members, realTimeTopIssueHour, realTimeTopIssueData, sortField, sortOrder, realTimeTopIssueCompareType) {
    let issues = [];
    const { accessDevices, crashDevices, prevHourAccessDevices, prevDaySameHourAccessDevices } = realTimeTopIssueData;

    if (curIssueData) {
      const issueList = TopIssueUtils.makeTopIssueEnrichedIssueList(realTimeTopIssueData, undefined, realTimeTopIssueCompareType)
        .map(x => ({
          ...x,
          firstUploadTime: moment(TimeUtil.fixChaosMillis(x.firstUploadTimestamp)).format('YYYY-MM-DD HH:mm:ss'),
          prevDayFluctuate: TopIssueUtils.calcFluctuatePercentage(x.crashUser, accessDevices, x.preDayCrashUser, prevDaySameHourAccessDevices),
          prevHourFluctuate: TopIssueUtils.calcFluctuatePercentage(x.crashUser, accessDevices, x.prevHourCrashDevices, prevHourAccessDevices),
          firstUploadTimestamp: x.firstUploadTimestamp,
        }));

      if (sortOrder && sortField) {
        issueList.sort((a, b) => {
          let ascRes = 0;
          if (sortField === FIELDS.FLUCTUATE_PREV_DAY) {
            ascRes = a.prevDayFluctuate - b.prevHourFluctuate;
          } else if (sortField === FIELDS.FLUCTUATE_PREV_HOUR) {
            ascRes = a.prevHourFluctuate - b.prevHourFluctuate;
          } else if (sortField === FIELDS.FIRST_TIME) {
            ascRes = a.firstUploadTimestamp - b.firstUploadTimestamp;
          } else if (sortField === FIELDS.NUM) {
            ascRes = a.crashNum - b.crashNum;
          } else if (sortField === FIELDS.DEVICES) {
            ascRes = a.crashUser - b.crashUser;
          }
          return sortOrder === 'ascend' ? ascRes : -ascRes;
        });
      }

      issues = issueList.map((issue, i) => {
        const { assigneeList } = issue.issueInfo || {};
        const isState1 = parseInt(issue.state) === 1;

        const assigneeListDisplayText = convertIssueAssigneeListToDisplayText(assigneeList);
        const { prevDayFluctuate, prevHourFluctuate } = issue;
        let prevDayArrowClassName = '';
        if (prevDayFluctuate > 0) {
          prevDayArrowClassName = 'increase';
        } else if (prevDayFluctuate < 0) {
          prevDayArrowClassName = 'decrease';
        }
        let prevHourArrowClassName = '';
        if (prevHourFluctuate > 0) {
          prevHourArrowClassName = 'increase';
        } else if (prevHourFluctuate < 0) {
          prevHourArrowClassName = 'decrease';
        }
        const { addTag, delTag } = actions;

        const issueDetailUrlPrefix = getIssueDetailUrlPrefix(pageType);

        issue.addTag = addTag;
        issue.delTag = delTag;
        issue.i = i;
        issue.style = style;
        issue.crashDevices  = crashDevices;
        issue.accessDevices = accessDevices;
        issue.assigneeListDisplayText = assigneeListDisplayText;
        issue.assigneeList = assigneeList;
        issue.isState1 = isState1;
        issue.issueDetailUrlPrefix = issueDetailUrlPrefix;
        issue.prevDayFluctuate = prevDayFluctuate;
        issue.prevDayArrowClassName = prevDayArrowClassName;
        issue.prevHourArrowClassName = prevHourArrowClassName;
        issue.prevHourFluctuate = prevHourFluctuate;
        issue.statusNo = parseInt(issue.state)
        return {
          issue: issue,
          problemAbnormal: issue,
          influenceEquipment: issue,
          comparisonYesterday: issue,
          comparisonPriorHour: issue,
          appearTime: issue,
          happenFrequency: issue,
          disposeState: issue,
        }
      });
    }
    return issues;
  }

  const selectOptions = reduxState.summary.get('selectOptions').toJS();
  const searchParams = reduxState.summary.get('searchParams').toJS();
  const { rankVersion } = selectOptions;
  const {
    realTimeTopIssueSortField,
    realTimeTopIssueVersion,
    realTimeTopIssueCountry,
    realTimeTopIssueLoading,
    realTimeTopIssueHour,
    realTimeTopIssueLimit,
    realTimeTopIssueVmSelectValue,
    realTimeTopIssueCompareDate,
    realTimeTopIssueEnableCrashFilter,
    realTimeTopIssueUserSceneTag,
    isQueryVital,
  } = searchParams;

  const realTimeTopIssueUserSceneTagList = (realTimeTopIssueUserSceneTag || '').split(',').filter(x => x);

  const realTimeTopIssueEnableCrashFilterValue = Number(realTimeTopIssueEnableCrashFilter || 0);

  const showExceptionCategoryTag = ExceptionCategoryUtil.isCrash(pageType) && !!isQueryVital;

  const bundleIdReduxState = reduxState.issue.get('selectOptions').get('bundleIdList');
  const bundleIdOptions = useMemo(() => (bundleIdReduxState.get ? bundleIdReduxState.get('options').toJS() : bundleIdReduxState.options).filter(x => x.value && x.value !== 'all'), [bundleIdReduxState]);

  const {
    compareType: realTimeTopIssueCompareType,
    customDateStr: realTimeTopIssueCustomCompareDateStr,
  } = TopIssueUtils.parseTopIssueCompareDateStr(realTimeTopIssueCompareDate, TopIssueCompareType.PREV_HOUR);

  const bigDataRealtimeUpdateMillis = reduxState.summary.get('bigDataRealtimeUpdateMillis');

  const versionListValue = realTimeTopIssueVersion !== ALL_VERSION
    ? CsvUtil.singleLineParse(realTimeTopIssueVersion)
    : [];
  const versionTree = rankVersion.versionTree;
  const isMultipleVersions = VersionUtil.isMultipleVersions(versionListValue);

  const vmTypeListValue = VmTypeUtil.vmSelectValueToVmTypeList(realTimeTopIssueVmSelectValue);

  const [countryListValue, setCountryListValue] = useState([]);
  useEffect(() => {
    setCountryListValue(CountryUtil.queryStringToList(realTimeTopIssueCountry));
  }, [realTimeTopIssueCountry]);

  const [realTimeTopIssueCrashFilterScg, setRealTimeTopIssueCrashFilterScg] = useState({
    conditions: [],
  });

  useEffect(() => {
    const realTimeTopIssueCrashFilterScgStr = searchParams.realTimeTopIssueCrashFilterScgStr;
    if (!realTimeTopIssueCrashFilterScgStr) {
      setRealTimeTopIssueCrashFilterScg({ conditions: [] });
      return;
    }
    try {
      const scg = JSON.parse(realTimeTopIssueCrashFilterScgStr);
      setRealTimeTopIssueCrashFilterScg(scg);
    } catch (e) {
      setRealTimeTopIssueCrashFilterScg({ conditions: [] });
    }
  }, [searchParams.realTimeTopIssueCrashFilterScgStr]);

  if (!realTimeTopIssueData) {
    return (<div></div>);
  }
  const curIssueData = realTimeTopIssueData['topIssueList'];

  useEffect(() => {
    if (curIssueData?.length && !isExpanded) {
      setIsExpanded(true);
    }
  }, [curIssueData])

  // 将01,02这种时间改成区间，01:00-02:00,02:00-03:00这样（10分钟粒度0910改成09:10-09:20）
  const formatDateTimeRange = (hourOrSlot) => {
    const raw = String(hourOrSlot || '');
    if (raw.length === 4 || raw.includes(':')) {
      const clean = raw.replace(':', '');
      const h = parseInt(clean.slice(0, 2), 10) || 0;
      const m = parseInt(clean.slice(2, 4), 10) || 0;
      const startLabel = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
      if (h === 23 && m >= 50) {
        return `${startLabel}-23:59`;
      }
      const totalNextMin = h * 60 + m + 10;
      const nextH = String(Math.floor(totalNextMin / 60)).padStart(2, '0');
      const nextM = String(totalNextMin % 60).padStart(2, '0');
      return `${startLabel}-${nextH}:${nextM}`;
    }
    const startHour = raw.padStart(2, '0');
    let endHour = '';

    if (raw === '23') {
      endHour = '23:59';
    } else {
      const nextHour = (parseInt(raw, 10) + 1).toString().padStart(2, '0');
      endHour = `${nextHour}:00`;
    }
    return `${startHour}:00-${endHour}`;
  }

  const enableTenMinuteTrend = !!serverAppSettings[ServerAppSettings.keys.enableTenMinuteTrend];
  const effectiveGranularity = searchParams.realTimeGranularity || (enableTenMinuteTrend ? '10m' : '1h');
  const isTenMinTopIssue = (enableTenMinuteTrend && effectiveGranularity === '10m')
    || String(realTimeTopIssueHour || '').length >= 12;
  const normalizedTopIssueSlot = isTenMinTopIssue && String(realTimeTopIssueHour || '').length === 10
    ? `${realTimeTopIssueHour}00`
    : String(realTimeTopIssueHour || '');
  const hour = normalizedTopIssueSlot.slice(8);
  let displayStr = `${transformDateFormat(normalizedTopIssueSlot.slice(0, 8))} ${formatDateTimeRange(hour)}`;

  const sortFieldOptions = [
    { label: ze('按设备数', 'By Affected Devices'), value: 'DEVICE_COUNT' },
    { label: ze('按次数', 'By Reports'), value: 'REPORT_COUNT' },
  ];

  const topIssueCountOptions = [5, 10, 20, 50]
    .map(x => ({ value: x, label: t(`DATATYPESELECT.topN`, { n: x }) }));

  const headArea = <CardHead
      title={ isTenMinTopIssue ? ze('每10分钟TOP问题', '10-Min Top Issues') : t("DATATYPESELECT.hourlyTopIssue") } hideDivider={!isExpanded} svgIcon={<HourlyTopIssiueIcon />}
      >
      <div style={{ display: 'flex',flexGrow: '1', alignItems: 'center', justifyContent: 'flex-end'}}>
        <UpdateTimeTag updateTime={bigDataRealtimeUpdateMillis} type="fiveMinute" />
        <CsDownloadButton onClick={(e) => downloading(e)} style={{marginLeft: '24px', marginRight: '24px'}} />
        {/* {
          collapseIssues ? <UpOutlined onClick={() => onToggleCollapseIssues()} /> : <DownOutlined onClick={() => onToggleCollapseIssues()} />
        } */}
        <CsCollapseButton
          extraStyle={{ width: '14px', height: '14px' }}
          isCollapsed={!isExpanded}
          enableHover={true}
          onClick={(e) => {
            e.stopPropagation();
            const newIsExpand = !isExpanded;
            setIsExpanded(newIsExpand);
            ReportEventUtil.reportCardHeadClickEvent('每小时TOP问题', true, newIsExpand);
          }}
        />
      </div>
      {/* <div style={{ flexGrow: '1', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}> */}
      {/* <div style={{paddingLeft:'20px'}}>
        <Button  icon={<DownloadOutlined />} onClick={() => downloading()}>
          {ze('下载数据', 'Download')}
        </Button>
      </div> */}
      {/* <div style={{ flexGrow: 1 }}/> */}

      {/* <Button type='link' onClick={() => onToggleCollapseIssues()}>
        {collapseIssues ? t("EXCP_OVERVIEW.collapse") : t("EXCP_OVERVIEW.expand")}
      </Button> */}
    </CardHead>;

  const empty = {
    emptyText:<EmptyData text={ t("REALTIMETOPISSUE.noData") } />
  }

  function createExcel(data, title){
    const { utils } = XLSX;
    var ws_name = "sheet1";
    const wb= utils.book_new();
    /* make worksheet */
    var ws = utils.aoa_to_sheet(data);
    /* Add the worksheet to the workbook */
    XLSX.utils.book_append_sheet(wb, ws, ws_name);
    XLSX.writeFile(wb, title);
  }

  //这个地方和TopIssueList 里面的formatPercentage 逻辑重复
  function formatPercentage(percentage) {
    if (percentage === Number.POSITIVE_INFINITY) {
      return '∞';
    }
    if (!Number.isFinite(percentage)) {
      return `${percentage}`;
    }
    if (Math.abs(percentage) >= 0.1 || percentage === 0) {
      return `${percentage.toFixed(2)} %`;
    }
    return `${percentage.toFixed(4)} %`;
  }

  const downloading = (e) => {
    e.stopPropagation();
    const topIssueEnrichedIssueList = renderIssue(actions, demoApp, curIssueData, handleChangeStatus, style, pageType, members, realTimeTopIssueHour, realTimeTopIssueData, sortField, sortOrder, realTimeTopIssueCompareType)
    const header = [
      t('issueCrashFilterKey.issueId'),
      ze('平台链接', 'Website URL'),
      t("issueCrashFilterKey.errorType"),
      t("TOPISSUELIST.exceptionInfo"),
      t("TOPISSUELIST.stack"),
      ix(t("TOPISSUELIST.affectedDevices")),
      t("TOPISSUELIST.proportion"),
      t("TOPISSUELIST.issueReportRate"),
      t("REALTIMETOPISSUE.occurNum"),
      t("TOPISSUELIST.firstPostTime"),
    ];
    const rows = topIssueEnrichedIssueList.map(item => [
      item.issue.issueId,
      `${window.location.origin}/${item.issue.issueDetailUrlPrefix}/${item.issue.appId}/${item.issue.issueId}?pid=${item.issue.platformId || item.issue.pid}`,
      item.issue.exceptionName,
      item.issue.exceptionMessage,
      item.issue.keyStack,
      formatNum(item.issue.crashUser),
      formatRate(item.issue.crashUser, item.issue.crashDevices),
      formatRate(item.issue.crashUser, item.issue.accessDevices),
      formatEnNumber(item.issue.crashNum),
      item.issue.firstUploadTime,
    ]);
    const filename = `${ t("DATATYPESELECT.hourlyTopIssue") }.xlsx`;
    createExcel([header, ...rows],filename);
  }

  const onLinkClicked = (issue) => {
    reportEvent({
      action: EVENT_ACTIONS.CLICK,
      tp1: '每小时TOP问题点击链接',
      tp6: `${window.location.origin}/${issue.issueDetailUrlPrefix}/${issue.appId}/${issue.issueId}?pid=${issue.platformId || issue.pid}`,
    })
  }

  const columns = [
    {
      title:<div className='table_th'>{ t("TOPISSUELIST.issue") }</div>,
      dataIndex:'problemAbnormal',
      width: 440,
      fixed: 'left',
      render: (issue) => <div>
        <Link
          to={`/${issue.issueDetailUrlPrefix}/${issue.appId}/${issue.issueId}?pid=${issue.platformId || issue.pid}`}
          className={topIssueListScss.link_item}
          rel="noopener noreferrer"
          target="_blank"
          onClick={() => onLinkClicked(issue)}
        >
          <div className="word_blue" style={{display:'flex',alignItems:'center'}}>
            {/* <img src={IssueIdIcon} style={{height: '12px', width: '12px', marginRight: '4px'}} />
            {issue.issueId.substr(0, 8) + '...'}
            <img src={IssueNameIcon} style={{height: '12px', width: '12px', margin: '0 4px'}} />
            <span style={{display:'inline-block', width:'200px', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>{issue.exceptionName}</span> */}

            <Space className={topIssueListScss.error_title} size={4}>
              { showExceptionCategoryTag && <div className={SearchItemScss[`type_logo_${getExceptionCategory(issue.issueInfo?.issueExceptionType)?.toLowerCase()}`]}>
                {getExceptionCategory(issue.issueInfo?.issueExceptionType)}
              </div> }
              {<div style={{marginRight: '-2px 4px 0 0'}}>{<IssueIdIcon />}</div>}
              {
                <Tooltip arrow={true}
                  placement="top"
                  title={(<div>{ issue.issueId }</div>)}
                >
                  {<div className={topIssueListScss.error_title_id}>{issue.issueId}</div>}
                </Tooltip>
              }
              {<div style={{margin: '-2px 4px 0'}}>{<IssueNameIcon />}</div>}
              {
                <Tooltip arrow={true}
                  placement="top"
                  title={(<div>{ issue.exceptionName }</div>)}
                >
                  {<div className={topIssueListScss.error_title_type}>{issue.exceptionName}</div>}
                </Tooltip>
              }
            </Space>
          </div>

        </Link>
        <div>
          <CsClampDiv
            lineHeight={1.15}
            lineClamp={3}
            style={{ whiteSpace: 'pre-line', overflowWrap: 'anywhere', lineHeight: '16px' }}
            showButton={!!itemIndexToIsHovering[issue.i]}
          >
              { issue.keyStack ? issue.keyStack : '-'  }
          </CsClampDiv>

        </div>
        <div>
          <TagList
            {...{
              tags: issue.tags, addTag: issue.addTag, delTag: issue.delTag, issueId: issue.issueId, appId:issue.appId, pid: issue.platformId,
              issueVersions: issue.issueVersions,
              firstUploadTimestamp: issue.firstUploadTimestamp,
              aiStatus: issue.issueInfo?.esMap?.aiStatus,
            }} />
        </div>
      </div>
    },
    {
      title: ix(t("TOPISSUELIST.affectedDevices")),
      sorter: true,
      dataIndex: FIELDS.DEVICES,
      width: isZh() ? 90 : 140,
      align: 'center',
      render: (text, record) => (<div style={{ position: 'relative' }}>
        <div>{`${record.issue.formattedCrashUser} `}</div>
        <div>
          { TopIssueUtils.makeFluctuateDom(record.issue.crashUserFluctuate) }
        </div>
      </div>)
    },
    {
      title: t("TOPISSUELIST.proportion"),
      dataIndex:'influenceEquipment',
      width: isZh() ? 70 : 86,
      align: 'center',
      render: (text, record) => (
        <div style={{ position: 'relative' }}>
          <div>{ record.issue.toAllCrashDevicesFormattedPercentage }</div>
          <div>
            { TopIssueUtils.makeFluctuateDom(record.issue.toAllCrashDevicesPercentageFluctuate) }
          </div>
        </div>
      )
    },
    {
      title: t("TOPISSUELIST.issueReportRate"),
      dataIndex:'influenceEquipment',
      width: isZh() ? 80 : 140,
      align: 'center',
      render: (text, record) => (
        <div style={{ position: 'relative' }}>
          <div>{record.issue.toAllAccessDevicesFormattedPercentage}</div>
          <div>
            { TopIssueUtils.makeFluctuateDom(record.issue.toAllAccessDevicesPercentageFluctuate) }
          </div>
        </div>
      )
    },
    {
      title: t("REALTIMETOPISSUE.occurNum"),
      dataIndex: FIELDS.NUM,
      sorter: true,
      align: 'center',
      width: isZh() ? 110 : 86,
      render: (text, record) => (
        <div style={{ position: 'relative' }}>
          <div>{ formatEnNumber(record.issue.crashNum) }</div>
          <div>
            { TopIssueUtils.makeFluctuateDom(record.issue.crashNumFluctuate) }
          </div>
        </div>
      )
    },
    /* {
      title:<div style={{ display: 'flex', justifyContent: 'center'}}>
        <span style={{paddingRight: 4}}>{ t("TOPISSUELIST.samePeriodGrowth") }</span>
        <Tooltip title={t("TOPISSUELIST.compareWithPrevDaySameHour")}>
          <WrappedTipsIcon />
        </Tooltip></div>,
      sorter: true,
      dataIndex: FIELDS.FLUCTUATE_PREV_DAY,
      width: isZh() ? 100 : 140,
      align: 'center',
      render: (_,{issue}) => (
        <div style={{ position: 'relative' }}>
          { TopIssueUtils.makeFluctuateDom(issue.prevDayFluctuate, issue.prevDayArrowClassName, issue.style, t) }
        </div>
      )
    },
    {
      title:<div style={{display: 'flex', justifyContent: 'center'}}>
        <span style={{paddingRight: 4}}>{ t("TOPISSUELIST.sequentialPeriodGrowth") }</span>
        <Tooltip title={t("TOPISSUELIST.compareWithPrevHour")}>
          <WrappedTipsIcon />
        </Tooltip>
      </div>,
      dataIndex: FIELDS.FLUCTUATE_PREV_HOUR,
      width: isZh() ? 100 : 150,
      sorter: true,
      align: 'center',
      render: (_,{issue}) => (
        <div style={{ position: 'relative' }}>
          { TopIssueUtils.makeFluctuateDom(issue.prevHourFluctuate, issue.prevHourArrowClassName, issue.style, t) }
        </div>
      )
    }, */
    {
      title: t("TOPISSUELIST.firstPostTime"),
      dataIndex: FIELDS.FIRST_TIME,
      width: isZh() ? 120 : 170,
      align: 'center',
      sorter: true,
      render: (_, {issue}) => <div title={issue.firstUploadTime}>{issue.firstUploadTime}</div>
    },
    {
      title: t("REALTIMETOPISSUE.status"),
      dataIndex:'disposeState',
      width: 120,
      align: 'center',
      render: (_, {issue}) => {
        return <StatusItem
          assigneeList={issue.assigneeList}
          statusNo={issue.statusNo}
          appId={issue.appId}
          pid={issue.platformId || issue.pid}
          issueId={issue.issueId}
          handleChangeStatus={() => { !DemoUtil.checkAndWarnIfDemoApp(demoApp) && handleChangeStatus(issue)}}
        />
      }
    },
    ...(showBugStatusField ? [{
      dataIndex: 'tapdStatus',
      title: <div className='table_th'>
        { !!tapdWorkspaceId && ze('TAPD状态', 'Tapd Status') }
        { !!jiraProjectId && ze('Jira缺陷单状态', 'Jira Issue Status') }
      </div>,
      width: 120,
      align: 'center',
      render: (_, {issue}) => {
        const record = issue;
        const bugInfo = record.bugs && record.bugs[0];
        if (bugInfo) {
          return <IssueTapdBugStatusEx
            needQueryStatus={true}
            currentApp={currentApp}
            issueId={record.issueId}
            tapdBugInfo={record.bugs && record.bugs[0]}
            onBugUnbind={() => onBugUnbind()}
          />;
        } else {
          return <Button
            type='link'
            style={{padding: '0', color: CS_STYLES.PRIMARY_COLOR }}
            onClick={() => onClickUpsertTapdBugByIssueIdList([record.issueId])}>{ze('创建', 'Create')}
          </Button>;
        }
      },
    }] : []),
  ]
  let columnWidth = 0;
  columns.forEach(item => {
    if (item.width) {
      columnWidth += item.width;
    }
  })
  const tableList = renderIssue(actions, demoApp, curIssueData, handleChangeStatus, style, pageType, members, realTimeTopIssueHour, realTimeTopIssueData, sortField, sortOrder, realTimeTopIssueCompareType);
  return <div className={topIssueListScss.topIssueList}>
    <Spin spinning={realTimeTopIssueLoading}>
      { headArea }
      { isExpanded &&
        <>
          <Row gutter={[10, 6]} align='middle' style={{marginTop: '20px', marginBottom: '20px'}}>
            <Col>
              <Select
                style={{ width: '200px' }}
                options={sortFieldOptions}
                value={realTimeTopIssueSortField || TopIssueSortField.DEVICE_COUNT}
                onChange={value => {
                  (value === 'REPORT_COUNT') && reportEvent({
                    action: EVENT_ACTIONS.CLICK,
                    tp1: '每小时TOP问题-按次数',
                  })
                  onRealTimeTopIssueParamsChange({ realTimeTopIssueSortField: value });
                }}
              />
            </Col>
            <Col>
              <Select
                style={{ width: '110px' }}
                options={topIssueCountOptions}
                value={realTimeTopIssueLimit}
                onChange={v => onRealTimeTopIssueParamsChange({ realTimeTopIssueLimit: v })}
              />
            </Col>
            {
              PlatformUtil.isVmTypeSupported(pid) && <Col>
                <VmTypeSelect
                  value={vmTypeListValue}
                  onChange={v => onRealTimeTopIssueParamsChange({ realTimeTopIssueVmSelectValue: VmTypeUtil.vmTypeListToVmSelectValue(v) })}
                />
              </Col>
            }
            <Col>
              <VersionHybridSelect
                style={{ width: '320px' }}
                value={versionListValue}
                treeData={versionTree}
                onChange={(v) => { onRealTimeTopIssueParamsChange({ realTimeTopIssueVersion: CsvUtil.singleLineStringify(v) || ALL_VERSION }); }}
              />
            </Col>
            <Col>
              <DatePicker
                style={{ width: '220px', cursor: 'pointer' }}
                allowClear={false}
                disabledDate={moment => moment && (moment.isBefore(datePickerMinAvailableMoment) || moment.isAfter(datePickerMaxAvailableMoment))}
                value={moment(normalizedTopIssueSlot, isTenMinTopIssue ? 'YYYYMMDDHHmm' : 'YYYYMMDDHH')}
                format={(value) => {
                  const slotArg = isTenMinTopIssue
                    ? `${String(value.hour()).padStart(2, '0')}${String(Math.floor(value.minute() / 10) * 10).padStart(2, '0')}`
                    : value.hour().toString();
                  return `${value.format('YYYY-MM-DD')} ${formatDateTimeRange(slotArg)}`;
                }}
                showTime={{ format: 'HH:mm', minuteStep: isTenMinTopIssue ? 10 : 60 }}
                suffixIcon={
                  <DateSelectIcon style={{ width: '12px', height: '12px' }} />
                }
                onChange={(v) => {
                  const nextSlot = isTenMinTopIssue
                    ? `${v.format('YYYYMMDDHH')}${String(Math.floor(v.minute() / 10) * 10).padStart(2, '0')}`
                    : v.format('YYYYMMDDHH');
                  onRealTimeTopIssueParamsChange({ realTimeTopIssueHour: nextSlot });
                }}
              />
            </Col>
            { isRegionalDashboard && <Col><CountrySelect
              style={{width: '320px', fontSize: '14px' }}
              value={countryListValue}
              isMultiple={true}
              onChangeWhenDropdownClosed={(v) => onRealTimeTopIssueParamsChange({ realTimeTopIssueCountry: CountryUtil.listToQueryString(v) })}
            /></Col> }
            { enableUserSceneTag && <Col>
              <UserSceneTagSelect
                isMultiple={true}
                style={{ width: '320px' }}
                value={realTimeTopIssueUserSceneTagList}
                onChangeWhenDropdownClosed={v => onRealTimeTopIssueParamsChange({ realTimeTopIssueUserSceneTag: (v || []).join(',') })}
              />
            </Col> }
            <Col><VitalOrCrashSelect /></Col>
          </Row>
          { isMultipleVersions && <div style={{ margin: '20px 0', width: '100%', color: orange.primary, fontSize: '14px' }}>
            <Space>
              <ExclamationCircleOutlined/>
              <div>{ t('EXCP_OVERVIEW.multipleVersionsWarning')}</div>
            </Space>
          </div> }
          <Row gutter={[10, 6]} align='middle' style={{ marginTop: '24px', marginBottom: '8px' }}>
            <Col>
              <span style={{ paddingLeft: '4px', paddingRight: '16px', color: '#807997'}}>{ze('对比', 'Comparison')}</span>
              <Radio.Group
                options={[
                  { label: t("TOPISSUELIST.samePeriodGrowth"), value: TopIssueCompareType.PREV_HOUR },
                  { label: t("TOPISSUELIST.sequentialPeriodGrowth"), value: TopIssueCompareType.PREV_DAY },
                  { label: ze('自定义日期', 'Custom'), value: TopIssueCompareType.CUSTOM },
                ]}
                value={realTimeTopIssueCompareType}
                onChange={(e) => {
                  const v = e.target.value;
                  reportEvent({
                    action: EVENT_ACTIONS.CLICK,
                    tp1: '点击切换实时top问题对比',
                  });
                  if (v !== TopIssueCompareType.CUSTOM) {
                    if (realTimeTopIssueCompareType === TopIssueCompareType.CUSTOM) {
                      onRealTimeTopIssueParamsChange({ realTimeTopIssueCompareDate: v });
                    } else {
                      patchQueryParams({ realTimeTopIssueCompareDate: v });
                    }
                  } else {
                    const defaultCustom = isTenMinTopIssue
                      ? `${moment().subtract(1, 'days').format('YYYYMMDDHH')}${String(Math.floor(moment().minute() / 10) * 10).padStart(2, '0')}`
                      : moment().subtract(1, 'days').format('YYYYMMDDHH');
                    onRealTimeTopIssueParamsChange({ realTimeTopIssueCompareDate: defaultCustom });
                  }
                }}
              />
              { realTimeTopIssueCompareType === TopIssueCompareType.CUSTOM && <DatePicker
                style={{ width: '220px', cursor: 'pointer' }}
                allowClear={false}
                disabledDate={moment => moment && (moment.isBefore(datePickerMinAvailableMoment) || moment.isAfter(datePickerMaxAvailableMoment))}
                value={moment(
                  isTenMinTopIssue && String(realTimeTopIssueCustomCompareDateStr || '').length === 10
                    ? `${realTimeTopIssueCustomCompareDateStr}00`
                    : realTimeTopIssueCustomCompareDateStr,
                  isTenMinTopIssue ? 'YYYYMMDDHHmm' : 'YYYYMMDDHH'
                )}
                format={(value) => {
                  const slotArg = isTenMinTopIssue
                    ? `${String(value.hour()).padStart(2, '0')}${String(Math.floor(value.minute() / 10) * 10).padStart(2, '0')}`
                    : value.hour().toString();
                  return `${value.format('YYYY-MM-DD')} ${formatDateTimeRange(slotArg)}`;
                }}
                showTime={{ format: 'HH:mm', minuteStep: isTenMinTopIssue ? 10 : 60 }}
                suffixIcon={
                  <DateSelectIcon style={{ width: '12px', height: '12px' }} />
                }
                onChange={(v) => {
                  const dateStr = isTenMinTopIssue
                    ? `${v.format('YYYYMMDDHH')}${String(Math.floor(v.minute() / 10) * 10).padStart(2, '0')}`
                    : v.format('YYYYMMDDHH');
                  onRealTimeTopIssueParamsChange({ realTimeTopIssueCompareDate: dateStr });
                }}
              /> }
            </Col>
            { isAppGameMatrix && <Col>
              <span style={{ paddingLeft: '4px', paddingRight: '16px', color: '#807997'}}>{ze('增加上报过滤条件', 'Add Report Filter')}</span>
              <Radio.Group
                options={[
                  { label: t("common.yes"), value: 1 },
                  { label: t("common.no"), value: 0 },
                ]}
                value={realTimeTopIssueEnableCrashFilterValue}
                onChange={(e) => {
                  if (e.target.value) {
                    reportEvent({
                      action: EVENT_ACTIONS.CLICK,
                      tp1: '小时级TOP问题-增加上报过滤条件'
                    });
                  }
                  onRealTimeTopIssueParamsChange({ realTimeTopIssueEnableCrashFilter: e.target.value });
                }}
              />
            </Col> }
          </Row>
          { !!realTimeTopIssueEnableCrashFilterValue && <div style={{marginTop: '20px'}}>
            <IssueCrashFilterEx
              platformId={pid}
              maxConditions={5}
              fieldWhitelist={[FieldName.bundleId, FieldName.gmCluster, FieldName.gmHardware, FieldName.gmGameId, FieldName.gmGameCluster]}
              filterOptions={{
                bundleId: bundleIdOptions,
              }}
              searchConditionGroup={realTimeTopIssueCrashFilterScg}
              onChange={({ searchConditionGroup }) => { setRealTimeTopIssueCrashFilterScg(searchConditionGroup); }}
              onSubmit={({ searchConditionGroup }) => {
                setRealTimeTopIssueCrashFilterScg(searchConditionGroup);
                onRealTimeTopIssueParamsChange({ realTimeTopIssueCrashFilterScgStr: JSON.stringify(searchConditionGroup) });
              }}
            />
          </div>
          }
          {
            tableList.length ? <>
              <Table
                size="small"
                scroll={{
                  x: `${columnWidth}px`,
                }}
                columns={columns}
                dataSource={tableList}
                showSorterTooltip={false}
                pagination={tableList.length > 10}
                locale={empty}
                rowClassName = { record => {
                  return record.issue.isState1 ? style.done : style.item
                }}
                onRow = { record => {
                  return {
                    onMouseEnter:  () => updateItemIndexToIsHovering(draft => ({ ...draft, [(record.issue).i]: true })),
                    onMouseLeave:  () => updateItemIndexToIsHovering(draft => ({ ...draft, [(record.issue).i]: false }))
                  }
                }}
                onChange = {(pagination, filters, sorter) => {
                  const { order, field } = sorter;
                  setSortField(field || null);
                  setSortOrder(order || null);
                }}
              />
              { tableList.length <= 10 && <div style={{height: '40px'}} />}
            </> : <EmptyData text={ t("REALTIMETOPISSUE.noData") } extraStyle={{paddingTop: 20, paddingBottom: 42}} />
          }
        </>
      }
    </Spin>
  </div>
};

RealTimeTopIssue.propTypes = {
  demoApp: PropTypes.bool,
  collapseIssues: PropTypes.bool,
  realTimeTopIssueData: PropTypes.object,
  style: PropTypes.object,
  handleChangeStatus: PropTypes.func,
  onToggleCollapseIssues: PropTypes.bool,
  onRealTimeTopIssueParamsChange: PropTypes.func,
  pageType: PropTypes.string,
  members: PropTypes.array,
  reduxState: PropTypes.object,
  actions: PropTypes.object,
  isRegionalDashboard: PropTypes.bool, // 是否是国家维度的大盘统计
};

const mapStateToProps = state => ({
  reduxState: state,
});

export default connect(mapStateToProps)(RealTimeTopIssue);
